// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1_unJ","actions":"GroupTable_actions__3Xejy","deleteModalFooter":"GroupTable_deleteModalFooter__3Ws7-"};